module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/98fb2b55ace28b640bdb0f160a7109fd.png";